import account from "./account.json";
import address from "./address.json";
import addressCreate from "./addressCreate.json";
import addressEdit from "./addressEdit.json";
import edit from "./edit.json";
import login from "./login.json";
import password from "./password.json";
import register from "./register.json";
import success from "./success.json";
import orders from "./orders.json";
import orderDetail from "./orderDetail.json";
import orderReturn from "./orderReturn.json";

export default {
  account,
  address,
  addressCreate,
  addressEdit,
  edit,
  login,
  password,
  register,
  success,
  orders,
  orderDetail,
  orderReturn,
};
